import React from "react";
import { Navigate } from "react-router-dom";
import { usePlatformAuth } from "context/PlatformAuthContext";

interface ProtectedRouteProps {
 children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
 const { isAuthenticated, loading } = usePlatformAuth();

 if (loading) {
  return <div className="p-8">Loading...</div>;
 }

 if (!isAuthenticated) {
  return <Navigate to="/platform/login" replace />;
 }

 return <>{children}</>;
};

export default ProtectedRoute;





